import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">Privacy Policy</h1>
      <div className="mt-8 space-y-6 text-base leading-7 text-slate-700">
        <p>
          This website is operated by Anand Deshmukh to share general information about financial planning,
          insurance guidance and investment discussions. We respect the privacy of visitors and aim to handle
          any personal information responsibly and transparently.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Information we may receive</h2>
        <p>
          Depending on how you contact us, the website may receive information such as your name, phone number,
          email address, service interest, message details and the purpose of your enquiry. This information is
          generally used to respond to a question, discuss a service requirement or provide guidance in a more
          relevant way.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">How we use information</h2>
        <p>
          We may use the information you provide to respond to an enquiry, understand the type of guidance requested,
          arrange a consultation or follow up about a service requirement. We do not use personal information for
          unrelated marketing purposes or to process sensitive financial details at the enquiry stage.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Analytics and cookies</h2>
        <p>
          This website may use analytics tools such as Google Analytics (GA4) to understand how visitors use the
          site, what pages are important and how the website may be improved over time. Analytics may involve the
          use of cookies or similar tracking technologies, depending on the configuration and browser settings.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Third-party services</h2>
        <p>
          Some features on the website may use third-party services for analytics, hosting or communication. The
          website currently uses Google Analytics (GA4) in the standard configuration for website usage analysis.
          Any additional services used for enquiry handling will be described on the site if and when they are
          configured.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Security</h2>
        <p>
          We aim to use reasonable administrative, technical and organisational measures to help protect personal
          information. No method of transmission over the internet or electronic storage is completely secure,
          and reasonable care should be exercised when sharing information online.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Your rights and contact</h2>
        <p>
          If you would like to ask a question about the information submitted through this website or to request a
          review or update of your enquiry information, you may contact us using the details on the website, including
          the phone number or email address listed on the Contact page.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Updates</h2>
        <p>
          This Privacy Policy may be updated from time to time to reflect changes in website use, services or legal
          requirements. The most recent version will be posted on this page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
